/**
 * @fileoverview GET handler for the "/alloys/partners/shopify/:integration_id/fetch_markets" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyFetchMarkets } from "./constants";
import type { GetAlloysPartnersShopifyFetchMarketsResult } from "./types";
import { isGetAlloysPartnersShopifyFetchMarketsResult } from "./validators";

export const getAlloysPartnersShopifyFetchMarkets = reactQueryFetcherAdapter(
  alloysPartnersShopifyFetchMarkets,
  (signal: AbortSignal, integrationId: string): Promise<GetAlloysPartnersShopifyFetchMarketsResult> => {
    return fetch(`/alloys/partners/shopify/${integrationId}/fetch_markets`, "GET", {}, { signal });
  },
  isGetAlloysPartnersShopifyFetchMarketsResult
);
